import * as Page from '../../components/content/page-header';
import { MainContent } from '../../components/layout/content';
import React, { useState } from 'react';
import { PageHeader } from '../../components/layout/page-header';
import { xor } from 'lodash';
import { TextInput } from '../../components/forms/input';
import { DatePicker } from '../../components/forms/date';
import { Radio } from '../../components/forms/radio';
import { useParams } from 'react-router-dom';

const audiences: { key: string; label: string }[] = [
  {
    key: 'fashion-websites',
    label: 'Fashion Websites',
  },
  {
    key: 'sport-websites',
    label: 'Sport Websites',
  },
  {
    key: 'music-websites',
    label: 'Music Websites',
  },
  {
    key: 'news',
    label: 'News',
  },
  {
    key: 'diy',
    label: 'DIY',
  },
  {
    key: 'magazine',
    label: 'Magazine',
  },
  {
    key: 'e-commerce',
    label: 'E-Commerce',
  },
  {
    key: 'blog',
    label: 'Blog',
  },
  {
    key: 'nonprofit-website',
    label: 'Nonprofit Website',
  },
  {
    key: 'educational-website',
    label: 'Educational Website',
  },
  {
    key: 'video-streaming',
    label: 'Video Streaming',
  },
];

type FormData = {
  audience?: string[];
  durationDays?: string;
  durationEndDate?: string;
  paymentType: string;
};

export const BlastChannel = (): JSX.Element => {
  const [formData, setFormData] = useState<FormData>({
    audience: ['blog', 'news', 'fashion-websites'],
    durationDays: '5',
    paymentType: 'metamask',
  });
  const { channelId } = useParams();

  const Section = (props: { title: string; children: JSX.Element }): JSX.Element => {
    return (
      <div className="blast-section">
        <h3>{props.title}</h3>
        {props.children}
      </div>
    );
  };

  const onChange = (key: string, value: any): void => {
    setFormData({ ...formData, [key]: value });
  };

  const Audience = (): JSX.Element => {
    return (
      <Section title="Audience">
        <ul className="audience-list">
          {audiences.map((audience): JSX.Element => {
            return (
              <li
                key={audience.key}
                className={(formData.audience || []).includes(audience.key) ? 'active' : undefined}
                onClick={(): void =>
                  onChange('audience', xor(formData.audience || [], [audience.key]))
                }>
                {audience.label}
              </li>
            );
          })}
        </ul>
      </Section>
    );
  };

  const Duration = (): JSX.Element => {
    return (
      <Section title="Duration">
        <div className="duration-container">
          <TextInput
            name={'durationDays'}
            label={'Days'}
            value={formData.durationDays as string}
            type={'number'}
            onChange={(event): void => {
              onChange('durationDays', event.target.value);
            }}
          />
          <DatePicker name={'endDate'} />
        </div>
      </Section>
    );
  };

  const Budget = (): JSX.Element => {
    return (
      <Section title="Budget">
        <div className="budget-container">
          <input type="range" className="form-range" id="customRange1" />
          <p>Estimated reach 1,4k - 4,3k per day</p>
        </div>
      </Section>
    );
  };

  const PaymentMethod = (): JSX.Element => {
    return (
      <Section title="Payment Method">
        <>
          <div className="payment-method-row">
            <Radio
              name={'paymentType'}
              label={'V 140'}
              value={'v140'}
              currentValue={formData.paymentType}
              onChange={(): void => {
                onChange('paymentType', 'v140');
              }}
              onBlur={(): void => {
                console.log('test');
              }}
            />
          </div>
          <div className="payment-method-row">
            <Radio
              name={'paymentType'}
              label={'METAMASK'}
              value={'metamask'}
              currentValue={formData.paymentType}
              onChange={(): void => {
                onChange('paymentType', 'metamask');
              }}
              onBlur={(): void => {
                console.log('test');
              }}
            />
          </div>
        </>
      </Section>
    );
  };

  return (
    <>
      <Page.Header>
        <PageHeader
          title="BLAST Channel"
          buttons={[
            { title: 'Edit Channel', type: 'link', location: `/channels/${channelId!}/edit` },
            {
              title: 'Adunit Preview',
              type: 'secondary',
              location: `/channels/${channelId!}/preview`,
            },
          ]}
        />
      </Page.Header>
      <MainContent className="blast-page">
        <div className="blast-container">
          <Audience />
          <Duration />
          <Budget />
          <PaymentMethod />
          <div className="blast-submit">
            <button>Blast</button>
          </div>
        </div>
      </MainContent>
    </>
  );
};
